import { ENEMY_ABILITIES, ENEMY_FIRST_APPEARANCE, ENEMY_ORDER, getEnemyDef } from "../game/constants/enemies";
import { EnemySpriteBadge } from "./SpriteBadge";

export function EnemyIntel({ mapIdx, mapDef = null, onClose = null }) {
	return (
		<section className="panel enemy-intel">
			<div className="panel__heading">
				<div>
					<div className="eyebrow">Intel</div>
					<h2>Hostile Roster</h2>
				</div>
				{onClose && (
					<button type="button" className="enemy-intel__close" aria-label="Close hostile roster" onClick={onClose}>
						x
					</button>
				)}
			</div>
			<div className="enemy-table">
				<div className="enemy-table__head">
					<span>Type</span>
					<span>W</span>
					<span>HP</span>
					<span>SPD</span>
					<span>G</span>
				</div>
				{ENEMY_ORDER.map((type) => {
					const enemy = getEnemyDef(type, { mapIdx, mapDef });
					return (
						<article key={type} className="enemy-row" style={{ "--tone": enemy.color }}>
							<div className="enemy-row__main">
								<span><EnemySpriteBadge type={type} />{enemy.name}</span>
								<span>{ENEMY_FIRST_APPEARANCE[type]}</span>
								<span>{enemy.hp}</span>
								<span>{enemy.speed}</span>
								<span>{enemy.reward}</span>
							</div>
							<p>{ENEMY_ABILITIES[type].join(" / ")}</p>
						</article>
					);
				})}
			</div>
		</section>
	);
}
